export default {
    title: "欢迎来到齿轮",
    header: "@:views.auth.login.title",
    message: "请使用您的公司凭据登录以继续。",
    disclaimer: "<p>通过选中此框，我承认我是公司员工，并且我同意公司及其合作伙伴 RemoteRetail 存储和处理在本网站上提交的个人信息，以便为我提供所要求的内容。 RemoteRetail 需要我提供的联系信息，以便他们可以与我联系并提供与我的订单相关的信息。第三方供应商也可能会收到我的信息以便向我运送产品。</p><p>我可以随时取消订阅这些通信。有关我如何取消订阅、隐私惯例以及保护和尊重我的隐私的承诺的更多信息，请查看<a href='{privacyPolicyUrl}' target='_blank'>隐私政策</a>。</p>",
    banner: {
        header:"Gear",
        message:"Gear - The source for accessories"
    }
}